module.exports = __webpack_public_path__ + "media/public/fonts/PragmaticaSlabLight/PragmaticaSlabLight-7cfee5dbf118c60dc6d11012cd9377a8.ttf";